import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Col, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { logout } from '../actions/userActions';

import exploraLogo from '../assets/images/explora-logos_transparent.png';

const Header = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);

  const logoutHandler = (e) => {
    dispatch(logout());
  };

  return (
    <header>
      <Navbar bg='primary' variant='dark' expand='lg' collapseOnSelect>
        <Container>
          <Col style={{ padding: 0 }} xs={5} md={6}>
            <LinkContainer to='/'>
              <Navbar.Brand>
                <img
                  src={exploraLogo}
                  style={{ maxWidth: '100px' }}
                  alt='logo explora'
                />
              </Navbar.Brand>
            </LinkContainer>
          </Col>
          <Col style={{ textAlign: 'right', padding: 0 }} xs={2} md={6}>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav className='ml-auto'>
                {userInfo ? (
                  <NavDropdown title={userInfo.name} id='username'>
                    <LinkContainer to='/profile'>
                      <NavDropdown.Item>Meus Dados</NavDropdown.Item>
                    </LinkContainer>
                    <NavDropdown.Item onClick={logoutHandler}>
                      Sair
                    </NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <Fragment>
                    <LinkContainer to='/login'>
                      <Nav.Link className='btn'>Login</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to='/register'>
                      <Nav.Link className='btn btn-light text-primary rounded'>
                        Registre-se
                      </Nav.Link>
                    </LinkContainer>
                  </Fragment>
                )}
              </Nav>
            </Navbar.Collapse>
          </Col>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
